<template>
  <div>

      <v-row class="mt-2" justify="center">
        <v-col cols="12" xs="12" sm="12" md="6" lg="4" xl="4">
          <v-card>
            <v-card-text>
               <v-row >
                <v-col xs="12" class="py-0 px-2">
                    <h2>{{lang.SalesPOSAnalysis}} </h2>
                </v-col>
              </v-row>
              <v-row >
                <v-col xs="12" class="py-0 px-2">
                    <span style="font-weight:bold">{{mainQuery.CompanyNameDatabase}}, {{mainQuery.BusinessYear}}</span>
                </v-col>
              </v-row>

              <v-row >
                <v-col xs="6" >
                  <v-dialog
                    ref="dialog1"
                    persistent
                    v-model="modal1"
                    width="290px"
                    :return-value.sync="startDate"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :value="formatDate1"
                        :label="langC.FromDate"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-on="on"
                        :rules="[rules.required]"
                      ></v-text-field>
                    </template>

                    <v-date-picker v-model="startDate" scrollable>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" @click="modal1 = false">Cancel</v-btn>
                      <v-btn color="primary" @click="$refs.dialog1.save(startDate)">OK</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-col>

                <v-col xs="6" >
                  <v-dialog
                    ref="dialog2"
                    persistent
                    v-model="modal2"
                    width="290px"
                    :return-value.sync="endDate"
                  >
                  <template v-slot:activator="{ on }">
                      <v-text-field
                        :value="formatDate2"
                        :label="langC.ToDate"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-on="on"
                        :rules="[rules.required]"
                      ></v-text-field>
                    </template>

                    <v-date-picker v-model="endDate" scrollable>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" @click="modal2 = false">Cancel</v-btn>
                      <v-btn color="primary" @click="$refs.dialog2.save(endDate)">OK</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-col>
              </v-row>

              <v-row >
                <v-col xs="6" >
                  <v-btn
                    block x-large
                    class="primary mr-3"
                    @click="fillData">
                    {{langC.Analysis}}
                  </v-btn>
                </v-col>
                <v-col xs="6" >
                  <v-btn block x-large color="success" @click="returnPOS" class="mr-5">Natrag na kasu</v-btn>
                </v-col>

              </v-row>

              <v-row >
                <v-col xs="6" >
                   <v-alert type="warning" v-model="havealert" dismissible close-text="Close Alert">
                        {{havemssgalert}}
                  </v-alert>
                </v-col>
              </v-row>

              <v-row>
                 <v-col xs="12" >
                   <DocumentPOSTotal v-if="items.length > 0 && Object.keys(period).length !== 0 && period.constructor === Object" :key="toSee" :items="items" :period="period" :totalDiscount="totalDiscount" :totalService="totalService" />
                 </v-col>
              </v-row>


              <v-row >
                <v-col xs="6" >
                  <v-btn block x-large color="gray" @click="doShowListTicket" class="mt-4 mr-3">
                    Lista računa
                  </v-btn>
                </v-col>
              </v-row>

              <v-row >
                <v-col xs="6" >
                  <v-btn block x-large color="gray" @click="doShowItems" class="mt-4 mr-3">
                    Po artiklima
                  </v-btn>
                </v-col>
              </v-row>

              <v-row v-if="showItems">
                 <v-col xs="12">
                   <DocumentPOSTotalItems v-if="itemDetItems.length > 0 && Object.keys(period).length !== 0 && period.constructor === Object" :key="toSee" :items="itemDetItems" :period="period"/>
                 </v-col>
              </v-row>

              <v-row >
                <v-col xs="6" >
                  <v-btn block x-large color="gray" @click="doShowGroups" class="mt-4 mr-3">
                    Po grupama
                  </v-btn>
                </v-col>
              </v-row>

              <v-row v-if="showGrups">
                 <v-col xs="12">
                   <DocumentPOSTotalGroups v-if="itemDet.length > 0 && Object.keys(period).length !== 0 && period.constructor === Object" :key="toSee" :items="itemDet" :period="period"/>
                 </v-col>
              </v-row>

              <v-row>
                <v-col xs="6" >
                <v-btn block x-large color="gray" @click="poscheck" class="mt-4">
                  Provjeri fisklizaciju
                </v-btn>
                </v-col>
              </v-row>


            </v-card-text>
          </v-card>
        </v-col>

            <v-progress-circular v-if="this.saving"
                  indeterminate
                  color="green"
            ></v-progress-circular>
      </v-row>
      <v-row v-if="showListTicket">
        <v-col>
          <v-data-table
              dense
              :headers="headers"
              :items="items"
              item-key="id"
              :search="search"
              :footer-props="{
                'items-per-page-options': [10, 20, 30, 40, 50]
              }"
              :items-per-page="50"
              @click:row="navigateTo"
            >

            <template v-slot:[`item.documentId`]="{ item }">
              <span class="headline">{{ (item.documentId) }}</span>
            </template>
            <template v-slot:[`item.documentDate`]="{ item }">
                <span class="headline">{{ localDate(item.documentDate) }}</span>
            </template>
            <template v-slot:[`item.documentTime`]="{ item }">
                <span class="headline">{{ localTime(item.documentTime) }}</span>
            </template>
            <template v-slot:[`item.documentTotalAmountBrutto`]="{ item }">
                <span class="headline">{{ localMoney(item.documentTotalAmountBrutto) }}</span>
            </template>
            <template v-slot:[`item.documentZKI`]="{ item }">
              <span class="headline">{{ (item.documentZKI) }}</span>
            </template>
            <template v-slot:[`item.documentJIR`]="{ item }">
              <span class="headline">{{ (item.documentJIR) }}</span>
            </template>
            <template v-slot:[`item.partnerName`]="{ item }">
              <span class="headline">{{ (item.partnerName) }}</span>
            </template>
            <template v-slot:[`item.status`]="{ item }">
              <span class="headline"><v-chip :color="getColor(item.status)" dark>{{ localStatus(item.status) }}</v-chip></span>
            </template>
            <template slot="pageText" slot-scope="{ pageStart, pageStop }">
              From {{ pageStart }} to {{ pageStop }}
            </template>
          </v-data-table>
        </v-col>
      </v-row>
  </div>


</template>

<script>
import DocumentService from '@/services/DocumentService'
import DocumentDetailService from '@/services/DocumentDetailService'
import DocumentPOSTotal from './DocumentPOSTotal'
import langEn from './documentDescEn'
import langHr from './documentDescHR'
import commEn from '@/language/commonEN'
import commHr from '@/language/commonHR'
import dateFormat from '@/snippets/dateFormat'
import moneyFormat from '@/snippets/moneyFormat'
import dayjs from 'dayjs'
import { fiskalRead, fiskalSave } from "@/components/Document/fiskal";
import { wait, dynamicSort } from "@/snippets/allSnippets";
import DocumentPOSTotalGroups from './DocumentPOSTotalGroups'
import DocumentPOSTotalItems from './DocumentPOSTotalItems'

export default {
  name: 'documentposlist',
  $_veeValidate: {
    validator: 'new'
  },
  data () {
    return {
      tmp: '',
      search: '',
      pagination: {},
      rowsPerPageItems: [50],
      headers: [],
      itemsLoc: [],
      selectIL: {},
      itemDet: [],
      itemDetItems: [],
      statewhs: false,
      rules: {
        required: value => !!value || '*'
      },
      menu: false,
      menu2: false,
      menu3: false,
      menu4: false,
      dateFormatted: null,
      dateFormatted2: null,
      modal: false,
      modal1: false,
      modal2: false,
      modal3: false,
      modal4: false,
      dialog1: false,
      dialog2: false,
      dialog3: false,
      dialog4: false,
      date1: null,
      date2: null,
      msg: '',
      comp: {},
      error: null,
      localError: false,
      size: 'sm',
      privitems: [],
      required: (value) => !!value || 'Required.',
      items: [],
      itemDetails: [],
      mainQuery: {
        CompanyId: 1
      },
      Total1: 0,
      Total2: 0,
      Total3: 0,
      Total4: 0,
      Total5: 0,
      Total6: 0,
      Total7: 0,
      Total8: 0,
      Total9: 0,
      PrintDate: null,
      lang: {},
      langC: {},
      saving: false,
      startDate: null,
      endDate: null,
      itemID: '',
      itemName: '',
      havemssgalert: '',
      havealert: false,
      period: {},
      totalDiscount : 0,
      totalService: 0,
      toSee: 1,
      showListTicket: false,
      showGrups: false,
      showItems: false
    }
  },
  async mounted () {
    if (this.$store.state.language === 'EN') {
      this.lang = langEn
      this.langC = commEn
    }
    if (this.$store.state.language === 'HR') {
      this.lang = langHr
      this.langC = commHr
    }
    this.mainQuery.CompanyId = this.$store.state.companyid ? this.$store.state.companyid : 0
    this.mainQuery.BusinessYear = this.$store.state.businessYear ? this.$store.state.businessYear : 2020
    this.mainQuery.CompanyNameDatabase = this.$store.state.companyName ? this.$store.state.companyName : ''

    this.headers.push(
      {text: 'Broj', value: 'documentId', width: '90px', class: "headline"},
      {text: this.lang.documentDate1, value: 'documentDate', width: '50px', class: "headline"},
      {text: this.lang.documentTime, value: 'documentTime', width: '30px', class: "headline"},
      {text: 'Iznos', value: 'documentTotalAmountBrutto', type: 'decimal', width: '80px', align: 'right', class: "headline"},
      {text: this.lang.documentJIR, value: 'documentJIR', width: '250px', class: "headline"},
      {text: this.lang.documentZKI, value: 'documentZKI', width: '250px', class: "headline"},
      {text: this.lang.partnerName, value: 'partnerName', width: '250px', class: "headline"},
    )
    this.$store.dispatch('settypePOSPrint', null)

    this.startDate = dayjs().format('YYYY-MM-DD')
    this.endDate = dayjs().format('YYYY-MM-DD')
    await this.fillData()

  },
  computed: {
    formIsValid () {
      return this.mainQuery.CompanyId !== null
    },
    formatDate1() {
      return this.startDate
        ? dateFormat(this.startDate)
        : "";
    },
    formatDate2() {
      return this.endDate
        ? dateFormat(this.endDate)
        : "";
    },
  },
  methods: {
    doShowListTicket() {
      this.showListTicket = !this.showListTicket
    },
    doShowGroups() {
      this.showGrups = !this.showGroups
    },
    doShowItems() {
      this.showItems = !this.showItems
    },
    async poscheck() {
      this.noFiskal = []
      this.mainQuery.CompanyId = this.$store.state.companyid
      this.mainQuery.BusinessYear = this.$store.state.businessYear
      const {data} = await DocumentService.documentfiskalcheck(this.mainQuery)

      if (data && data.documents !== undefined && data.documents.length > 0) {
        const haveIt = data.documents.length
        this.noFiskal = data.documents
        const warningMessage = 'Imate ' + haveIt + ' nefiskaliziranih računa. Fiskalizacija traje oko ' + (haveIt * 4)+ ' sekundi. Želite ih fiskalizirati sada?'
          if (confirm(  warningMessage + '!')) {
            this.fiskalDone()
          }
      } else {
        // show all is OK message
        this.text = 'Svi računi su fiskalizirani!'
        this.color = 'green'
        this.snackbar = true
      }
    },
    async fiskalDone(){
      if (this.noFiskal.length > 0) {
        //const haveIt = this.noFiskal.length

        //let done = 0
        this.noFiskal.map(async(doc) => {
          const id = doc.id
          this.saving = true
          await fiskalSave(id, doc, 'P')
          // wait 2 seconds and try read reponse
          wait(3000)
          this.fiskalStatus = await fiskalRead(1, id)
          console.log(this.fiskalStatus);
          
          this.saving = false
          if (this.fiskalStatus.status === 'GRESKA FISKALIZACIJE!!!') {
            this.text = 'NIJE USPJELA FISKALIZACIJA! Račun ' + doc.documentId
            this.color = 'red'
            this.snackbar = true
          }
          if (this.fiskalStatus.status === 'Fiskalizacija OK.') {
            this.text = 'FISKALIZACIJA USPJELA! Račun ' + doc.documentId
            this.color = 'green'
            this.snackbar = true
          }
          //done += 1
        })


        // if (haveIt === done) {
        //   this.havealert = false
        //   this.havealert = true
        //   this.alerttype = 'success'
        //   this.havemssgalert = 'Svi racuni su fiskalizirani!'
        // } else {
        //   this.havealert = false
        //   this.havealert = true
        //   this.alerttype = 'warning'
        //   this.havemssgalert = 'NIJE USPJELA FISKALIZACIJA! Broj nefiskaliziranih računa = ' + haveIt
        // }
      }
    },
    async fillData(){
        this.havealert = false
        this.mainQuery.documentName = 'POS'
        if (this.startDate) {
          this.mainQuery.docFromDate = dayjs(this.startDate).format('YYYY-MM-DD')
        }
        if (this.endDate) {
          this.mainQuery.docToDate = dayjs(this.endDate).format('YYYY-MM-DD')
        }
        this.itemDet.length = 0
        this.itemDetItems.length = 0
        this.Total1 = 0
        this.Total2 = 0
        this.Total3 = 0
        this.Total4 = 0
        this.Total5 = 0
        this.Total6 = 0
        this.totalDiscount = 0
        this.totalService = 0
        this.saving = true
        this.items.length = 0
        this.itemDetails.length = 0
        this.itemDet.length = 0
        this.itemDetItems.length = 0
        console.log('Trazim i this.mainQuery', this.mainQuery)

        await DocumentService.documentsalesana(this.mainQuery)
        .then((res) => {
          this.items = res.data.document ? res.data.document : []
          if (this.items.length === 0) {
            this.havealert = true
            this.havemssgalert = 'Za period ' + dayjs(this.startDate).format('DD.MM.YYYY') + ' do ' + dayjs(this.endDate).format('DD.MM.YYYY') + ' nema racuna kase.'
          }
        })
        .catch((err) => {
          this.items.length = 0
          this.havealert = true
          this.havemssgalert = 'Za period ' + dayjs(this.startDate).format('DD.MM.YYYY') + ' do ' + dayjs(this.endDate).format('DD.MM.YYYY') + ' nema racuna kase.'
          // eslint-disable-next-line
          console.log(err)
        })

        await DocumentDetailService.salesana(this.mainQuery)
        .then(res => {
          this.itemDetails = res.data.document ? res.data.document : []
          if (this.itemDetails) {
            this.itemDet = [...this.itemDetails]
            this.itemDet.sort(dynamicSort("itemGroup"))
            this.itemDetItems = [...this.itemDetails]
            this.itemDetItems.sort(dynamicSort("itemID"))
            this.itemDetails.map(item=> {
              this.totalDiscount += parseFloat(item.itemDiscountAmount1)
              if (item.itemService === true) {
                this.totalService += parseFloat(item.itemFullTotal)
              }
            })
          }
        })
        .catch((err) => {
          this.itemDetailss = []
          // eslint-disable-next-line
          console.log(err)
        })
        this.period.startDate = this.startDate
        this.period.endDate = this.endDate
        this.saving = false
        this.toSee += 1
    },
    formatDate (date) {
      if (!date) {
        return null
      }
      const [year, month, day] = date.split('-')
      return `${day}.${month}.${year}`
    },
    localMoney(moneyToFormat) {
      return moneyFormat(moneyToFormat)
    },
    localDate(dateToFormat) {
      return dateFormat(dateToFormat)
    },
    localTime(timeToFormat) {
      return timeToFormat.substr(0,5)
    },
    returnPOS() {
      this.$store.dispatch('setDocumentActivHead', {})
      this.$store.dispatch('setDocumentActivItems', [])
      this.$router.push({name: 'documentpos'})
    },
    parseDate (date) {
      if (!date) {
        return null
      }
      const [day, month, year] = date.split('.')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    async navigateTo (params) {
      try {

        const dbDocument = await DocumentService.show(params.id)
        if (dbDocument) {
          this.$store.dispatch('setDocumentActivHead', dbDocument.data.document)
        } else {
          this.$store.dispatch('setDocumentActivHead', {})
        }
        this.$store.dispatch('setDocumentid', params.id)
        this.$store.dispatch('setDatabaseDocID', params.id)
        if (this.$store.state.companyid) {
          this.mainQuery.CompanyId = this.$store.state.companyid
        }
        if (this.$store.state.businessYear) {
          this.mainQuery.businessYear = this.$store.state.businessYear
        }
        if (this.$store.state.documentActiv) {
          this.mainQuery.documentName = this.$store.state.documentActiv
        }
        if (this.$store.state.databaseDocID) {
          this.mainQuery.databaseDocID = this.$store.state.databaseDocID
        }
        if (this.$store.state.documentSide) {
          this.docSide = this.$store.state.documentSide
        }
        this.items = (await DocumentDetailService.index(this.mainQuery)).data.documentDetails
        if (this.items) {
          this.$store.dispatch('setDocumentActivItems', this.items)
        } else {
          this.$store.dispatch('setDocumentActivItems', [])
        }
        this.$store.dispatch('setprintSmall', false)
        this.$store.dispatch('setprintNoPrice', false)
        this.$router.push({
          name: 'documentposagain'
        })

      } catch (err) {
        // eslint-disable-next-line
        console.log('error read from database', err)
      }
    },
    close () {
      this.show = false
    },
    async documentlist () {
      try {
        this.havePath = this.$store.state.retPath
        this.$store.dispatch('setretPath', '')
        await this.$router.push({
          name: 'home'
        })
      } catch (err) {
        console.log(err)
      }
    }
  },
  watch: {

  },
  components: {
    DocumentPOSTotal,
    DocumentPOSTotalGroups,
    DocumentPOSTotalItems
  }
}
</script>

<style >

</style>
